import {Component, Injector, Renderer2} from '@angular/core';
import {PlayerBase} from "./player.base";
import {GenericElm} from "./generic.elm";
import {Observable, of, switchMap} from "rxjs";
import {Expiration} from "../interfaces/Expiration";
import {CachingService} from "../services/caching/caching.service";
import {catchError, finalize} from "rxjs/operators";
import {IPlayerContainer} from "../interfaces/IPlayerContainer";
import {DateUtils} from "../utils/DateUtiles";


@Component({
  selector: 'app-item',
  template: '<div #component></div>',
  styleUrls: []
})
export class ItemComponent extends PlayerBase {
  renderer: Renderer2;
  genericElm: GenericElm;
  fieldType;
  aspectRatio = false;
  folder;

  metadata;
  dateFormat;


  constructor(protected  injector: Injector) {
    super(injector);
    this.renderer = injector.get(Renderer2);
  }


  invalidateData(providerData: any, playVideoInFull: boolean): Observable<any> {
    this.providerData = providerData;
    this.genericElm.clear();
    if (providerData==null) {
      if (this.editMode) {
        if (this.fieldType === 'text' || this.fieldType === 'date') {
          this.genericElm.setText('TEXT', false);
        } else {
          this.genericElm.setEmptyIcon(this.renderer);
        }
      }
      return of(null);
    } else {
      const ar = this.fieldName.split('.');
      let value = providerData;
      try {
        ar.forEach(item => {
          value = value[item];
        })
        if (value==null) {
          value = "";
        }
      } catch (e) {
        value = "";
      }

      switch (this.fieldType) {
        case 'text':
          return this.invalidateText(value);

        case 'date':
          return this.invalidateDate(value);

        case 'resource':
          return this.invalidateResource(value);

        case 'html':
          return this.invalidateHtml(value, true);

        case 'object':
          return this.invalidateObject(value);
      }
    }
    return of('invalidate');
  }

  invalidateText(value): Observable<any> {
    this.genericElm.setText(value);
    return of('text');
  }

  invalidateResource(value): Observable<any> {
    let obs$ = null;
    value = String(value);
    if (value.length > 10 && value.substring(0, 10) == '$resource.') {
      const resourceId = value.substring(10);
      obs$ =  (<CachingService>this.playerService.caching).getResource(resourceId);
    } else {
      if (this.parentPlayer?.parentPlayer!=null) {
        const url = (<IPlayerContainer>(this.parentPlayer.parentPlayer)).getItemUrl(value);
        if (url==null || value=="") {
          return of('empty');
        }
        obs$ = this.playerService.caching.requestUrl(url, this.folder, Expiration.Never);
      } else {
        return of(null);
      }

    }
    return obs$.pipe(
      switchMap(path => {
        let volume = 1.0;
        if (this.parentPlayer?.parentPlayer!=null) {
          volume = (<IPlayerContainer>(this.parentPlayer.parentPlayer)).volume;
        }
        return this.genericElm.setMedia(<string>path, this.aspectRatio, this.actualWidth, this.actualHeight, false, volume);
      }),
      catchError( e => {
          debugger;
          return this.invalidateHtml(value, false)
      }) // some url have CORS issue
    )
  }

  invalidateDate(value): Observable<any> {
    const date = new Date(value);
    const str = DateUtils.showDate(date, this.dateFormat)
    this.genericElm.setText(str);
    return of('text');
  }

  invalidateHtml(value, scrollbars): Observable<any> {
    return this.playerService.allowDomain(value).pipe(
      switchMap( a => this.genericElm.setHtml(value, scrollbars))
    )
  }

  invalidateObject(value): Observable<any> {
    return of(null);
  }

  play(): Observable<any> {
    if (this.editMode) {
      this.display(true);
      return of('play');
    }

    let playVideoInFull = false;
    if (this.parentPlayer?.parentPlayer!=null) {
      playVideoInFull = (<IPlayerContainer>(this.parentPlayer.parentPlayer)).playVideoInFull
    }

    return super.play().pipe(
      switchMap(a => {
        if (this.genericElm != null) {
          return this.genericElm.play(playVideoInFull);
        } else {
          return of('play');
        }
      })
    )
  }

  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
      this.genericElm = null;
    }
    super.destroy();
  }
}
